import React from 'react';
import Select from 'react-select';

const PonBoxContainerCanton = ({toggleVisibilityPonBox, isVisiblePonBox, ponboxData, handleChangePonBox, selectedPonBox, commentPonBox, commentTextAreaRefPonBox,
      handleCommentChangePonBox, togglePonBoxMarker, ponBoxMarker, ponBoxSave}) => {

  return (
    <React.Fragment>
      <button onClick={toggleVisibilityPonBox} className={isVisiblePonBox ? 'buttonIsHideDrawer2' : 'buttonIsHideDrawer'} >
        {isVisiblePonBox ? 'Пон-бокс: скрыть' : 'Пон-бокс: показать'}
      </button>
      {isVisiblePonBox && (
        <div className='divСommunicationsDrawer'>
       
           <img src='./ponbox.png' width='30' height='30' style={{ marginRight: "5px" }} />
          
          <label className='textTitleDrawer'>Пон-бокс</label>
          <hr className="horizontalLineDrawer" />
          <div>
           <select className="selectStyleDrawer" style={{ marginBottom: "5px", marginTop: "10px" }} onChange={handleChangePonBox} value={selectedPonBox}>
              <option value="null">Выберите пон-бокс</option>
              {ponboxData.map(fob => (
                <option key={fob.id} value={fob.id}>{fob.name}</option>
              ))}
            </select>
            {/* <br/>
            <select className="selectStyleDrawer" style={{ marginTop: "10px"}} onChange={handleChangeRankComponentPonBox} value={selectedRankPonBox}>
              <option value="null">Относится к узлу</option>
              {rankComponentData.map(rank => (
                <option key={rank.id} value={rank.id}>{rank.name}</option>
              ))}
            </select> */}
            <hr className="horizontalLineDrawer" style={{ marginTop: "10px" }} />          

          </div>
          <div >

            <textarea
              className='areaDescriptionDrawer'
              placeholder="Комментарий"
              rows={3}
              cols={44}
              value={commentPonBox}
              ref={commentTextAreaRefPonBox}
              onChange={handleCommentChangePonBox}
            />
            <button onClick={togglePonBoxMarker} className={ponBoxMarker ? 'buttonIsDrawingDrawer2' : 'buttonIsDrawingDrawer'}>
              {ponBoxMarker ? 'Завершить' : 'Добавить'}
            </button>
            <button onClick={ponBoxSave} className='buttonSaveDrawer'>Сохранить</button>
          </div>
        </div>
      )}
    </React.Fragment>
  );
}

export default PonBoxContainerCanton;